{
    "common": {
        "mon": "Mán",
        "tue": "Þri",
        "wed": "Mið",
        "thu": "Fim",
        "fri": "Fös",
        "sat": "Lau",
        "sun": "Sun",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",        
        "jun": "Jún",
        "jul": "Júl",
        "aug": "Ágú",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nóv",
        "dec": "Des",
        "january": "Janúar",
        "february": "Febrúar",
        "march": "Mars",
        "april": "Apríl",
        "may": "Maí",
        "june": "Júní",
        "july": "Júlí",
        "august": "Ágúst", 
        "september": "September",
        "october": "Október",
        "november": "Nóvember",
        "december": "Desember",
        "checkin": "Innritun",
        "checkout": "Útritun",
        "room": "Herbergi",
        "rooms": "Herbergi",
        "adult": "Fullorðinn",
        "adults": "Fullorðnir",
        "edit": "Breyta",
        "editCap": "BREYTA",
        "delete": "Eyða",
        "deleteCap": "EYÐA",
        "localTime": "Staðartími",
        "back": "TIL BAKA",
        "home": "HEIM",
        "yes": "JÁ",
        "no": "NEI",
        "left": "Eftir",
        "hour": "Klukkustund",
        "hours": "Klukkustundir",
        "night": "nótt",
        "nights": "nætur",
        "for": "fyrir",
        "why": "Hvers vegna",
        "get": "Fá",
        "more": "Meira",
        "agree": "SAMMÁLA",
        "disagree": "ÓSAMMÁLA",
        "basedOn": "byggt á",
        "error": "Villa kom upp, reyndu aftur síðar",
        "error2": "Mistókst, reyndu aftur!",
        "error3": "Villa kom upp!!",
        "error4": "Villa kom upp!! Reyndu aftur",
        "error5": "Því miður!! Villa kom upp. Reyndu aftur eftir smá stund.",
        "hi": "Hæ",
        "to": "til",
        "free": "Ókeypis",
        "per": "Á",
        "at": "á",
        "day": "Dagur",
        "days": "Dagar",
        "time": "Tími",
        "of": "af",
        "photo": "Mynd",
        "photos": "Myndir",
        "done": "Lokið",
        "fullStay": "Allt dvöl",
        "date": "Dagsetning",
        "and": "og",
        "bookingDetail": "Bókunarupplýsingar",
        "Back": "Til baka",
        "Home": "Heim"
    },
    "userPopup": {
        "myAccount": "Reikningur minn",
        "welcome": "Velkomin",
        "user": "Notandi",
        "findMyBookings": "FINNA BÓKANIR MÍNAR",
        "viewProfile": "SKOÐA PRÓFÍL",
        "makeAReservarion": "GERA BÓKUN",
        "logout": "SKRÁ ÚT",
        "loginCap": "SKRÁ INN",
        "login": "Skrá inn",
        "invalidCredentials": "Ógild skilríki",
        "invalidEmail": "Ógilt netfang",
        "passwordIsRequired": "Lykilorð er nauðsynlegt",
        "minChar8": "lágmark 8 stafir",
        "tooShort": "Of stutt!",
        "tooLong": "Of langt!",
        "required": "Nauðsynlegt",
        "emailInvalid": "Sláðu inn gilt netfang",
        "passwordInvalid": "Sláðu inn gilt lykilorð",
        "phNumInvalid": "Símanúmer er ekki gilt",
        "signupCap": "SKRÁ SIG",
        "signup": "Skrá sig",
        "verifyText": "Staðfestu að það sért þú",
        "verifyText2": "Við sendum staðfestingarkóða á netfangið þitt",
        "verificationCode": "Staðfestingarkóði",
        "didNotReceiveEmail": "Fékkst ekki tölvupóst",
        "clickToResend": "Smelltu til að senda aftur",
        "verifyAndSignIn": "Staðfesta og skrá inn",
        "otpSentSuccessfully": "OTP sent með góðum árangri",
        "somethingWentWrong": "Eitthvað fór úrskeiðis, reyndu aftur",
        "otpError": "Vinsamlegast sláðu inn gilt númer",
        "otpError2": "Vinsamlegast sláðu aðeins inn tölur",
        "otpError3": "Rangt OTP, reyndu aftur",
        "otpError4": "OTP útrunnið, smelltu á Senda aftur til að reyna aftur",
        "otpError5": "Vinsamlegast reyndu aftur",
        "forgetPassword": "Gleymt lykilorð",
        "submitError": "Notandi er ekki til!",
        "userExistError": "Notandi er þegar til",
        "checkYourEmail": "Athugaðu tölvupóstinn þinn",
        "passwordResetLinkSent": "Við höfum sent lykilorðsendurstillingartengil á",
        "noWorriesResetInstructions": "Engar áhyggjur, við sendum þér endurstillingarleiðbeiningar.",
        "enterYourEmail": "Sláðu inn netfangið þitt",
        "resetMyPassword": "ENDURSTILLA LYKILORÐ MITT",
        "setANewPassword": "Setja nýtt lykilorð",
        "newPassword": "Nýtt lykilorð",
        "confirmPassword": "Staðfesta lykilorð",
        "confirmPasswordError": "Lykilorð verða að passa saman",
        "backToLogin": "Til baka til innskráningar",
        "dontHaveAccount": "Ertu ekki með reikning?",
        "alreadyHaveAccount": "Ertu þegar með reikning?",
        "memberDiscount1": "Þú færð",
        "memberDiscount2": "aðildarafslátt að eilífu.",
        "discount1": "Stjórnaðu öllum pöntunum þínum frá einum stað.",
        "discount2": "Skráðu þig fyrir persónulegar ráðleggingar og sérsniðna upplifun!!",
        "discount3": "Vertu hluti af samfélagi okkar ánægðra gesta og byrjaðu að skipuleggja dvöl þína.",
        "leftGridText1": "Stjórnaðu öllum pöntunum þínum frá einum stað",
        "leftGridText2": "Skráðu þig fyrir persónulegar ráðleggingar og sérsniðna upplifun!!",
        "leftGridText3": "Vertu hluti af samfélagi okkar ánægðra gesta og byrjaðu að skipuleggja dvöl þína",
        "gridDiscountText1": "aðildarafsláttur á",
        "gridDiscountText2": "valdar eignir að eilífu",
        "gridDiscountText3": "Skráðu þig inn fyrir sérsniðna upplifun að eilífu",
        "gridDiscountText4": "Fáðu einkarétt aðildarkosti",
        "findBookingError": "Netfangið þitt og bókunarnúmer passa ekki saman",
        "verifyAndConfirmBooking": "Staðfesta og staðfesta bókun",
        "confirmEmailText": "Við höfum sent staðfestingarkóða á netfangið þitt",
        "enterCodeText": "Vinsamlegast sláðu inn staðfestingarkóðann sem sendur var til þín",
        "didNotRecieveEmail": "Fékkstu ekki tölvupóst?",
        "changeEmailText": "Smelltu hér til að breyta netfanginu",
        "verifyAndConfirm": "Staðfesta og staðfesta",
        "verified": "STAÐFEST",
        "bookingExpired": "Bókun útrunnin",
        "bookingExpiredText": "Því miður, bókunarnúmerið sem þú ert að nota er útrunnið",
        "backToFindingBooking": "Til baka til að finna bókun",
        "findMyBooking": "Finna bókanir mínar",
        "bookingEmail": "Bókunartölvupóstur",
        "reservationId": "Bókunarnúmer",
        "findBooking": "FINNA BÓKUN",
        "abandonmentCartDoneText1": "Takk fyrir!",
        "abandonmentCartDoneText2": "Körfuupplýsingarnar hafa verið sendar á tölvupóstinn. Haltu áfram bókun þinni hvenær sem er.",
        "Recommended Currencies": "Ráðlagðir gjaldmiðlar",
        "All currencies": "Allir gjaldmiðlar",
        "thisIsRequiredField": "Þetta er nauðsynlegt svæði"
    },
    "widget": {
        "destination": "Áfangastaður",
        "enterDestination": "Sláðu inn áfangastað",
        "guests": "Gestir",
        "guest": "Gestur",
        "nationality": "Þjóðerni",
        "selectNationality": "Veldu þjóðerni",
        "nationalityIsRequired": "Þjóðerni er nauðsynlegt",
        "selectedRate": "Sérverð",
        "search": "Leita",
        "ages": "Aldur",
        "orAbove": "Eða eldri",
        "child": "Barn",
        "children": "Börn",
        "addAnotherRoom": "Bæta við öðru herbergi",
        "removeRoom": "Fjarlægja herbergi",
        "property": "Eign",
        "city": "Borg",
        "country": "Land",
        "bookNow": "Bóka núna",
        "overnightStay": "Gisting yfir nótt",
        "dayUse": "Dagnotkun",
        "destinationIsRequired": "Áfangastaður er nauðsynlegur",
        "checkInIsRequired": "Innritunardagur er nauðsynlegur",
        "checkOutIsRequired": "Útritunardagur er nauðsynlegur",
        "noLocationFound": "Engin staðsetning fannst",
        "soldOut": "Uppselt",
        "highDemand": "Mikil eftirspurn",
        "dates": "Dagsetningar",
        "allRates": "Öll verð eru í",
        "K": "Þ",
        "M": "M",
        "sameDayCheckout": "Sama dags útritun"
    },
    "promotion": {
        "headingText": "Mikilvægar upplýsingar fyrir",
        "regularRate": "Ekkert",
        "seniorCitizen": "Verð fyrir eldri borgara",
        "agencyRate": "Verð fyrir umboð",
        "caaRate": "CAA/AAA verð",
        "corporateRate": "Fyrirtækjaverð",
        "governmentRate": "Ríkis/herverð",
        "promotionalSpecialRate": "Kynningar/sérstakt verð",
        "regularRateDescription": "Engin kynning notuð.",
        "seniorCitizenRateDescription": "Þetta er afsláttarverð hótels sem er mjög aðgengilegt fyrir eldri fullorðna, venjulega 60 ára eða eldri.",
        "agencyRateDescription": "Þetta er afsláttarverð hótels sem boðið er upp á sem aðeins er hægt að nálgast í gegnum tiltekin ferðaskrifstofur sem stuðla að samstarfi og samvinnu.",
        "caaRateDescription": "Þetta er sérstakt hótelverð sem boðið er meðlimum AAA eða CAA fyrir einkarétt sparnaðar.",
        "corporateRateDescription": "Þetta er afsláttarverð hótels sem útvíkkað er fyrir viðskiptaferðamenn, venjulega samið um milli hótelsins og fyrirtækisins.",
        "governmentRateDescription": "Þessi verðáætlun býður upp á sérstaka afslætti fyrir ríkis/herstarfsfólk fyrir bókun hótelherbergis.",
        "contentSeniorCitizen": "Sönnun fæðingardags er skylda við innritun. Ef ekki er framvísað viðeigandi skilríkjum mun það leiða til gjalda á gildandi gjöldum.",
        "contentAgencyRate": "Gakktu úr skugga um að þú hafir bókunarstaðfestingu þína og skilríkjasönnun við komu. Ef ekki er framvísað þessu mun það leiða til þess að staðalverð er beitt.",
        "contentPromotionalSpecialRate": "Þetta er afsláttarverð hótels sem boðið er upp á í takmarkaðan tíma, oft tengt sérstökum viðburðum, árstíðum eða markaðsherferðum.",
        "contentCaaRate": "Vinsamlegast gakktu úr skugga um að þú hafir CAA félagskortið þitt eða viðeigandi auðkenningu við innritun. Ef ekki er framvísað viðeigandi skilríkjum mun það leiða til gjalda á gildandi gjöldum.",
        "contentCorporateRate": "Sönnun fyrirtækis skilríkja eða annarra opinberra skjala er krafist við innritun. Ef ekki er framvísað viðeigandi sönnun mun það leiða til gjalda á gildandi gjöldum.",
        "contentGovernmentRate": "Gild ríkis- eða herskilríki verða að vera framlögð við innritun. Ef ekki er framlögð nauðsynleg auðkenning mun það leiða til gjalda á staðalverði.",
        "CORP": "FYRIRTÆKI",
        "AGEN": "UMBOÐ",
        "PROM": "KYNNING",
        "apply": "NOTA",
        "Offer Code": "Tilboðskóði",
        "Agency Code": "Umboðskóði",
        "Corporate Code": "Fyrirtækjakóði",
        "All-Access Rate": "Allur aðgangsverð",
        "errorCode": "Þessi kóði er ekki gildur"
    }
}